import styled from 'styled-components/macro';

export const CryptoBadgeDownloadItem = styled.div`
  margin-top: 23px;
  h3 {
    font-size: 1.4rem;
  }
  p {
    max-width: 685px;
    margin-bottom: 40px;
  }
`;

export const CryptoBadgeItemTitleDiv = styled.div`
  display: flex;
  margin: 20px 0px;
`;

export const CryptoBadgeDownloadLinkA = styled.a`
  padding: 0rem 1rem;
  color: ${props => props.theme.dustyGray};
  &:hover {
    color: ${props => props.theme.blue};
    text-decoration: underline;
  }
  @media screen and (max-width: 374px) {
    padding: 0rem;
  }
`;

export const BorderDiv = styled.div`
  border-left: 1px solid ${props => props.theme.dustyGray};
  margin: 0px 21px;
  @media screen and (max-width: 374px) {
    margin: 0px 12px;
  }
`;

export const DownloadImageLinkA = styled.a`
  img {
    width: 445px;
  }
  @media screen and (max-width: 767px) {
    img {
      width: 300px;
    }
  }
`;

export const CollateralItemDiv = styled.div`
  margin-top: 88px;
  h4 {
    margin-bottom: 10px;
  }
  p {
    margin-bottom: 20px;
    max-width: 685px;
  }
  a {
    cursor: pointer;
    ${props => props.theme.fontStackHeader};
    font-weight: 500;
    color: ${props => props.theme.blue};
    text-decoration: underline;
    letter-spacing: 0.04em;
  }
`;
